/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Fit {
    INSIDE = 'Inside',
    COVER = 'Cover',
    OUTSIDE = 'Outside',
}
